
// Actions
const PREFIX = 'calculus/adapters/';

export const SET_ADAPTERS  = PREFIX + 'SET_ADAPTERS';

const INITIAL_STATE = {
  loading: true,
  data: []
};

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_ADAPTERS:
      return {
        ...state,
        data: payload,
        loading: false
      };

    default:
      return state;
  }
}

// Action Creators
export function setValvesFittings(payload) {
  return {
    type: SET_ADAPTERS,
    payload: payload
  };
}
